import { useState, useEffect } from "react";

function useHelpInformationGet() {

const [helpInfo, setHelpInfo] = useState([]);

useEffect(() => {
  fetch(`${process.env.REACT_APP_API_URL}/percept_db/v1/audio?type=help&sound=all`)
    .then((response) => response.json())
    .then((data) => {
      setHelpInfo(data.data);
    })
    .catch((error) => {
      console.error("Error fetching help data:", error);
    });
}, []);

return helpInfo;
}

export default useHelpInformationGet;